import { Injectable } from '@angular/core';

const WeekdayMap = new Map()
  .set(0, '星期日')
  .set(1, '星期一')
  .set(2, '星期二')
  .set(3, '星期三')
  .set(4, '星期四')
  .set(5, '星期五')
  .set(6, '星期六');

@Injectable({
  providedIn: 'root'
})
export class DateService {

  constructor() { }

  YYMM(rawDate) {
    const tempDate = new Date(rawDate);
    const year = tempDate.getFullYear().toString().slice(2);
    let month = (1 + tempDate.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;
    return year + month;
  }

  YYYYMMDD(code, rawDate) {
    const tempDate = new Date(rawDate);
    const year = tempDate.getFullYear();
    let month = (1 + tempDate.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;
    let day = tempDate.getDate().toString();
    day = day.length > 1 ? day : '0' + day;
    if (code === 0) { // 欄位格式
      return year + '-' + month + '-' + day;
    } else if (code === 1) {
      return year + '/' + month + '/' + day;
    } else if (code === 2) {
      const weekDay = WeekdayMap.get(tempDate.getDay());
      return year + '/' + month + '/' + day + weekDay;
    }
  }

  YYYYMMDDHHMM(code, rawDate) {
    const tempDate = new Date(rawDate);
    const year = tempDate.getFullYear();
    let month = (1 + tempDate.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;
    let day = tempDate.getDate().toString();
    day = day.length > 1 ? day : '0' + day;
    let hour = tempDate.getHours().toString();
    hour = hour.length > 1 ? hour : '0' + hour;
    let minute = tempDate.getMinutes().toString();
    minute = minute.length > 1 ? minute : '0' + minute;
    if (code === 0) { // 欄位格式
      return year + '-' + month + '-' + day + 'T' + hour + ':' + minute;
    } else if (code === 1) {
      return year + '/' + month + '/' + day + ' ' + hour + ':' + minute;
    } else if (code === 2) {
      return year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
    }
  }

  YYYYMMDDHHMMSS(code, rawDate) {
    const tempDate = new Date(rawDate);
    const year = tempDate.getFullYear();
    let month = (1 + tempDate.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;
    let day = tempDate.getDate().toString();
    day = day.length > 1 ? day : '0' + day;
    let hour = tempDate.getHours().toString();
    hour = hour.length > 1 ? hour : '0' + hour;
    let minute = tempDate.getMinutes().toString();
    minute = minute.length > 1 ? minute : '0' + minute;
    let second = tempDate.getSeconds().toString();
    second = second.length > 1 ? second : '0' + second;
    if (code === 0) { // 欄位格式
      return year + '-' + month + '-' + day + 'T' + hour + ':' + minute + ':' + second;
    } else if (code === 1) {
      return year + '/' + month + '/' + day + ' ' + hour + ':' + minute + ':' + second;
    } else if (code === 2) {
      return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
    } else if (code === 3) {
      return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second + '+08';
    }
  }

  HHMMSS(code, rawDate) {
    const tempDate = new Date(rawDate);
    let hour = tempDate.getHours().toString();
    hour = hour.length > 1 ? hour : '0' + hour;
    let minute = tempDate.getMinutes().toString();
    minute = minute.length > 1 ? minute : '0' + minute;
    let second = tempDate.getSeconds().toString();
    second = second.length > 1 ? second : '0' + second;
    if (code === 0) { // 欄位格式
      return hour + ':' + minute + ':' + second;
    }
  }

  dateComparison(date1, date2): boolean {
    const cDate1 = new Date(date1).getTime();
    const cDate2 = new Date(date2).getTime();
    if (cDate1 > cDate2) return true;
    return false;
  }

}
